import { json, postBiz, rows } from '../core/coreapi';

import { BieRecordId } from './bieonboardingworkbench.models';
import { IBieOnboardingReviewValidateResult } from './bieonboardingreview.models';
import { normalizeBieOnboardingReviewValidateResult } from './bieonboardingreview.normalizers';
import {
  normalizeLoadSessionId,
  normalizeLoadSessionStamp,
} from './bieonboarding.normalize';


const SERVICE = 'bieonboardingreview';

export async function validateBieOnboardingReview(
  loadSessionId: BieRecordId,
  stamp: string,
): Promise<IBieOnboardingReviewValidateResult> {
  const response = await postBiz({
    s: SERVICE,
    a: 'validate',
    lsi: normalizeLoadSessionId(loadSessionId),
    stp: normalizeLoadSessionStamp(stamp),
  });

  return normalizeBieOnboardingReviewValidateResult(json(response));
}